export default __webpack_public_path__ + "static/media/approved-icon.fbab28e9.png";